import { createFileRoute, Outlet } from "@tanstack/react-router";
import { LogoImage } from "@/components/ui/logo-image";
import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/v-stack";

function QrLayout({ children }: { children: React.ReactNode }) {
  return (
    <VStack align="center" justify="center" className="min-h-screen p-4">
      <div className="mb-6">
        <LogoImage width={180} height={70} />
      </div>
      <div className="w-full max-w-md">{children}</div>
      <Text size="xs" color="muted" className="mt-8" align="center">
        &copy; {new Date().getFullYear()} Yuklar
      </Text>
    </VStack>
  );
}

export const Route = createFileRoute("/qr")({
  component: function LayoutRoute() {
    return (
      <QrLayout>
        <Outlet />
      </QrLayout>
    );
  },
});
